import { MediaSource, MediaType } from '../../../types/media';

interface IImportedMediaItem {
  type: MediaType;
  source: MediaSource;
  url: string;
  name: string;
  selected?: boolean;
  error?: any;
  previewImage?: string;
}

enum MediaImportStatus {
  NO_ANY_MEDIA,
  NO_FACEBOOK_MEDIA,
  NO_SITE_MEDIA,
  HAS_ANY_MEDIA,
}

export { IImportedMediaItem, MediaImportStatus };
